import { motion } from "framer-motion";
import { Check, ArrowUpRight, Lock, Clock, XCircle } from "lucide-react";

export default function OfferResult({ tier, onContinue }) {
  if (!tier) return null;
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -30 }}
      transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
      className="w-full max-w-2xl mx-auto"
      data-testid="offer-result"
    >
      <span className="text-xs font-bold tracking-[0.25em] uppercase text-[#8b5cf6]">
        La tua soluzione su misura
      </span>

      <div className="mt-5 relative rounded-3xl border border-[#6d28d9]/50 bg-gradient-to-b from-[#6d28d9]/10 to-transparent p-8 sm:p-10 overflow-hidden">
        <div
          className="glow-orb"
          style={{ width: 300, height: 300, background: "#6d28d9", top: "-120px", right: "-80px", opacity: 0.35 }}
        />
        <h2 className="relative font-display font-black tracking-tight text-3xl sm:text-4xl text-white leading-tight">
          {tier.name}
        </h2>
        <p className="relative mt-1 text-[#c4b5fd] font-medium">{tier.expert}</p>
        <p className="relative mt-3 text-zinc-400">{tier.tagline}</p>

        <div className="relative mt-5 flex flex-wrap gap-2">
          <span className="inline-flex items-center gap-1.5 rounded-full border border-[#8b5cf6]/40 bg-[#6d28d9]/15 px-3 py-1.5 text-xs font-semibold text-[#c4b5fd]">
            <Lock className="h-3 w-3" /> Percorso privato · lezioni private
          </span>
          <span className="inline-flex items-center gap-1.5 rounded-full border border-white/10 bg-white/5 px-3 py-1.5 text-xs font-semibold text-zinc-300">
            <Clock className="h-3 w-3" /> Durata: {tier.duration}
          </span>
          <span className="inline-flex items-center gap-1.5 rounded-full border border-white/10 bg-white/5 px-3 py-1.5 text-xs font-semibold text-zinc-300">
            <XCircle className="h-3 w-3" /> Nessun videocorso
          </span>
        </div>
        <p className="relative mt-4 text-sm text-zinc-400 leading-relaxed">
          Un percorso <span className="text-white font-medium">strutturato e disegnato su misura</span> per la tua azienda, con lezioni private dal vivo — non un videocorso preregistrato.
        </p>

        <div className="relative mt-8 flex flex-wrap items-end gap-x-6 gap-y-2">
          <div>
            <span className="block text-xs uppercase tracking-widest text-zinc-500">
              Soluzione unica
            </span>
            <span className="font-display font-black text-4xl text-white">
              {tier.price_full}
            </span>
          </div>
        </div>

        <ul className="relative mt-8 space-y-3">
          {tier.format && (
            <li className="mb-2 text-[11px] font-bold tracking-[0.2em] uppercase text-[#8b5cf6]">
              {tier.format}
            </li>
          )}
          {tier.features.map((f, i) => (
            <motion.li
              key={i}
              initial={{ opacity: 0, x: -15 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.2 + i * 0.08 }}
              className="flex items-start gap-3 text-zinc-300"
            >
              <span className="mt-0.5 flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full bg-[#6d28d9]">
                <Check className="h-3 w-3 text-white" />
              </span>
              {f}
            </motion.li>
          ))}
        </ul>
      </div>

      <motion.button
        onClick={onContinue}
        whileHover={{ scale: 1.02 }}
        whileTap={{ scale: 0.97 }}
        data-testid="offer-continue-btn"
        className="group mt-8 w-full inline-flex items-center justify-center gap-3 rounded-full bg-[#6d28d9] hover:bg-[#8b5cf6] px-8 py-4 text-base font-semibold text-white transition-colors"
      >
        Prenota la tua consulenza gratuita
        <span className="flex h-7 w-7 items-center justify-center rounded-full bg-white/15 group-hover:rotate-45 transition-transform">
          <ArrowUpRight className="h-4 w-4" />
        </span>
      </motion.button>
    </motion.div>
  );
}
